interface GrayAlertIconProps {
  size?: number;
}

export const GrayAlertIcon = ({ size = 24 }: GrayAlertIconProps) => {
  const iconSize = Number(size) || 24;
  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#C9BBBE" />
      <g clipPath="url(#clip0_5598_18183)">
        <path
          d="M20 20.9375V14.375"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.2715 8.75H15.7285C15.6054 8.7499 15.4834 8.77407 15.3696 8.82112C15.2558 8.86817 15.1524 8.93719 15.0652 9.02422L9.02422 15.0652C8.93719 15.1524 8.86817 15.2558 8.82112 15.3696C8.77407 15.4834 8.7499 15.6054 8.75 15.7285V24.2715C8.7499 24.3946 8.77407 24.5166 8.82112 24.6304C8.86817 24.7442 8.93719 24.8476 9.02422 24.9348L15.0652 30.9758C15.1524 31.0628 15.2558 31.1318 15.3696 31.1789C15.4834 31.2259 15.6054 31.2501 15.7285 31.25H24.2715C24.3946 31.2501 24.5166 31.2259 24.6304 31.1789C24.7442 31.1318 24.8476 31.0628 24.9348 30.9758L30.9758 24.9348C31.0628 24.8476 31.1318 24.7442 31.1789 24.6304C31.2259 24.5166 31.2501 24.3946 31.25 24.2715V15.7285C31.2501 15.6054 31.2259 15.4834 31.1789 15.3696C31.1318 15.2558 31.0628 15.1524 30.9758 15.0652L24.9348 9.02422C24.8476 8.93719 24.7442 8.86817 24.6304 8.82112C24.5166 8.77407 24.3946 8.7499 24.2715 8.75Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M20 26.5625C20.7767 26.5625 21.4062 25.9329 21.4062 25.1562C21.4062 24.3796 20.7767 23.75 20 23.75C19.2233 23.75 18.5938 24.3796 18.5938 25.1562C18.5938 25.9329 19.2233 26.5625 20 26.5625Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5598_18183">
          <rect width="30" height="30" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
